import { CurrencyPipe } from '@angular/common';
import { Component } from '@angular/core';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-currency-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  template: `@if (this.value) {
    <div class="align-end currency-cell">
      {{ this.value | currency }}
    </div>
  }`,
  imports: [CurrencyPipe],
})
export class GridCurrencyCellComponent extends AbstractCellComponent<any, string> {}
